import { Pipe, PipeTransform } from '@angular/core';
import { UserGroupKey } from '../models/user.models';

@Pipe({
  name: 'userGroup',
})
export class UserGroupPipe implements PipeTransform {
  transform(userGroup: UserGroupKey): string {
    const dict: Record<UserGroupKey, string> = {
      [UserGroupKey.Client]: 'Client',
      [UserGroupKey.Expert]: 'Expert',
      [UserGroupKey.Internal]: 'Internal',
      [UserGroupKey.NetworkDevelopment]: 'Network development',
      [UserGroupKey.ProjectManager]: 'Project manager',
      [UserGroupKey.ServiceProvider]: 'Service provider',
      [UserGroupKey.System]: 'System',
    };

    return dict[userGroup] || '';
  }
}
